import React from 'react'
import Price from '../../PositionColumns/Price'
import PnlPrice from '../../PositionColumns/PnlPrice'
import UserTag from '../../UserTag'
import EntryTime from '../../PositionColumns/EntryTime'
import { Text, View } from '../../../../styles/reactnative'

export const column_referral = (mutate, onClick) => {
	return [
		{
			title: '날짜',
			dataIndex: 'sent_at',
			key: 'sent_at',
			align: 'center',
			width: 150,
			render: (text, record) => {
				return <EntryTime time={text} />
			},
		},
		{
			title: '수익',
			dataIndex: 'amount',
			align: 'center',
			key: 'amount',
			render: (text, record) => (
				<View>
					<PnlPrice
						price={text}
						krw={record?.symbol == 'KRW' ? true : false}
						usdt={record?.symbol == 'USDT' ? true : false}
						dp={record?.symbol == 'KRW' ? 0 : undefined}
					/>
				</View>
			),
		},
		{
			title: '하위회원',
			dataIndex: 'info',
			key: 'info',
			align: 'center',
			width: 200,
			render: (text, record) => {
				return (
					<View>
						<UserTag
							style={{ justifyItems: 'flex-start' }}
							userid={record?.info}
							email={record?.email}
							phone={record?.phone}
							nickname={record?.fullname || record?.nickname}
							onClick={() => {
								onClick(record?.info)
							}}
						/>
					</View>
				)
			},
		},
		{
			title: '',
			dataIndex: 'arrow',
			key: 'arrow',
			width: 15,
			render: (text, record) => <Text>{'>'}</Text>,
		},
		{
			title: '받은회원',
			dataIndex: 'info',
			key: 'info',
			width: 80,
			render: (text, record) => {
				return (
					<UserTag
						userid={record?.user_id}
						email={record?.email}
						nickname={record?.fullname || record?.nickname}
						phone={record?.phone}
						onClick={() => {
							onClick(record?.user_id)
						}}
					/>
				)
			},
		},
	]
}
